export const LAST_WIDGET_SORT_ORDER = 999;
